module.exports = __webpack_public_path__ + "images/marketing/content-background-patrick5.jpg";